export default "__VITE_ASSET__B7HE3FnV__"